var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStorage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 55,
    viewBox: "0 0 44 55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1130",
    "data-name": "\\uADF8\\uB8F9 1130",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uC0AC\\uAC01\\uD615_1344",
    "data-name": "\\uC0AC\\uAC01\\uD615 1344",
    transform: "translate(0)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 55,
    rx: 5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 41,
    height: 52,
    rx: 3.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uAD50\\uCC28_11",
    "data-name": "\\uAD50\\uCC28 11",
    transform: "translate(0)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,17.349V5A5,5,0,0,1,5,0H18.564A14.349,14.349,0,0,1,19,3.522,14.563,14.563,0,0,1,4.354,18,14.8,14.8,0,0,1,0,17.349Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 4.35420036315918 15 C 7.471330642700195 15 10.4001407623291 13.80177021026611 12.60109996795654 11.62602996826172 C 14.79285049438477 9.459400177001953 15.99990081787109 6.581230163574219 15.99990081787109 3.521699905395508 C 15.99990081787109 3.347536087036133 15.99594879150391 3.173560380935669 15.98807048797607 3 L 5.000400543212891 3 C 3.897380352020264 3 3.000000476837158 3.89697003364563 3.000000476837158 4.999499797821045 L 3.000000476837158 14.9233922958374 C 3.44763708114624 14.97436809539795 3.899682760238647 15 4.35420036315918 15 M 4.35420036315918 18 C 2.838140487670898 18 1.375390410423279 17.77211952209473 4.089355343239731e-07 17.34938049316406 L 4.089355343239731e-07 4.999499797821045 C 4.089355343239731e-07 2.238300085067749 2.238300323486328 0 5.000400543212891 0 L 18.56357955932617 0 C 18.84863090515137 1.127470016479492 18.99990081787109 2.306900024414062 18.99990081787109 3.521699905395508 C 18.99990081787109 11.5181999206543 12.44250011444092 18 4.35420036315918 18 Z",
    stroke: "none",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_127",
    "data-name": "\\uC120 127",
    x1: 41.951,
    transform: "translate(1.654 35.608)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "\\uD0C0\\uC6D0_129",
    "data-name": "\\uD0C0\\uC6D0 129",
    cx: 2.5,
    cy: 3,
    rx: 2.5,
    ry: 3,
    transform: "translate(31 42)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStorage);
export default __webpack_public_path__ + "static/media/storage.494e838cb095b65a5aec496aa1e373e3.svg";
export { ForwardRef as ReactComponent };